import { Card, CardContent, Skeleton, Stack } from "@mui/material"
import { COLOR_MAP } from "../../../constants/ColorNames"

const BottomPanelSkeleton = () => {

    return (<Stack bgcolor={COLOR_MAP.WHITE} >
        <Card>
            <CardContent >
                <Stack spacing={1}>
                    <Stack
                        justifyContent='end'
                        direction='row'
                        spacing={1}
                        width='100%' >
                        {Array(3).fill('')
                            .map((_, i) => (

                                <Skeleton
                                    key={i}
                                    width='10%'
                                    variant="rectangular"
                                    height={30} />

                            ))

                        }

                    </Stack>

                </Stack>
            </CardContent>
        </Card>

    </Stack>)
}

export default BottomPanelSkeleton